import { Text, TextField } from "@radix-ui/themes";
import {
  Controller,
  FieldPath,
  FieldValues,
  UseFormReturn,
} from "react-hook-form";

export function HookFormTextField<T extends FieldValues>({
  label,
  formMethods,
  name,
  ...props
}: TextField.RootProps & {
  label?: string;
  name: FieldPath<T>;
  formMethods: UseFormReturn<T>;
}) {
  return (
    <Controller
      control={formMethods.control}
      name={name}
      render={({ field, fieldState: { error } }) => (
        <Text as="label">
          {label && (
            <Text as="p" size="1" className="mb-0.5">
              {label}
            </Text>
          )}
          <TextField.Root size="1" {...props} {...field}></TextField.Root>
          {error && (
            <Text size="1" color="red" as="p" className="mt-0.5">
              {error.message}
            </Text>
          )}
        </Text>
      )}
    />
  );
}
